import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import {createRequestOption, createRequestBody} from '../../shared/util';
import {environment} from '../../../environments/environment';

type EntityResponseType = HttpResponse<any>;
type EntityArrayResponseType = HttpResponse<any[]>;

@Injectable({ providedIn: 'root' })
export class ProductService {
  public resourceUrl = environment.SERVER_API_URL + 'api/product/';

  constructor(protected http: HttpClient) {}

  create(body: any) {
    return this.http.post<any>(this.resourceUrl, body, { observe: 'response' });
  }

  update(body: any) {
    return this.http.put<any>(environment.SERVER_API_URL +`api/product/${body.id}/update-product-parent`, body);
  }

  updateProgram(body: any) {
    return this.http.put<any>(environment.SERVER_API_URL +`api/product/${body.id}/update-product-program`, body);
  }

  find(id: number) {
    return this.http.get<any>(`${this.resourceUrl}${id}`, { observe: 'response' });
  }
  getListProduct(req?: any) {
    const body = createRequestBody(req);
    return this.http.post<any[]>(this.resourceUrl + 'programs/list', body);
  }
  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  updateStatus(body: any) {
    return this.http.patch<any>(environment.SERVER_API_URL +`api/product/${body.id}/change-status`, body, { observe: 'response' });
  }
  updateLogo(body: any) {
    return this.http.patch<any>(environment.SERVER_API_URL +`api/product/${body.id}/change-avatar`, body, { observe: 'response' });
  }
  updateInfoTab(type, body) {
    switch (type) {
      case 'generic':
        this.updateGenericInfoTab(body);
      break;
      case 'protection':
        this.updateProtectionBenefitTab(body);
      break;
      case 'investment':
        this.updateInvestmentBenefitTab(body);
      break;
      case 'charge-fee':
        this.updateChargeFeeTab(body);
      break;
      case 'interest':
        this.updateInterestTab(body);
      break;
      case 'extra':
        this.updateExtraInfoTab(body);
      break;
    }
  }
  updateGenericInfoTab(body: any) {
    return this.http.put<any>(environment.SERVER_API_URL +`api/product/${body.id}/generic-info-tab`, body, { observe: 'response' });
  }
  updateProtectionBenefitTab(body: any) {
    return this.http.put<any>(environment.SERVER_API_URL +`api/product/${body.id}/protection-benefit-tab`, body, { observe: 'response' });
  }
  updateInvestmentBenefitTab(body: any) {
    return this.http.put<any>(environment.SERVER_API_URL +`api/product/${body.id}/investment-benefit-tab`, body, { observe: 'response' });
  }
  updateChargeFeeTab(body: any) {
    return this.http.put<any>(environment.SERVER_API_URL +`api/product/${body.id}/charge-fee-tab`, body, { observe: 'response' });
  }
  updateInterestTab(body: any) {
    return this.http.put<any>(environment.SERVER_API_URL +`api/product/${body.id}/interest-tab`, body, { observe: 'response' });
  }
  updateExtraInfoTab(body: any) {
    return this.http.put<any>(environment.SERVER_API_URL +`api/product/${body.id}/extra-info-tab`, body, { observe: 'response' });
  }
  changeAvatar(body: any) {
    return this.http.post(environment.SERVER_API_URL +`api/product/${body.id}/change-avatar`, body, { observe: 'response' });
  }
  getOrgAgencies() {
    return this.http.get<any>(`${environment.SERVER_API_URL}api/res/agency-organizations/`);
  }
  getInsuranceFactor(body: any) {
    return this.http.get(environment.SERVER_API_URL +`api/product/${body.id}/insurance-factor-setting`, { observe: 'response' });
  }
  updateInsuranceFactor(productId: number, body: any) {
    return this.http.put(environment.SERVER_API_URL +`api/product/${productId}/insurance-factor-setting`, body, { observe: 'response' });
  }
  readFileFactor(body: any) {
    return this.http.post<any>(environment.SERVER_API_URL +`api/product/insurance-factor-setting/read-file`, body);
  }
  getSumAssuredParamSetting(productId: number) {
    return this.http.get(environment.SERVER_API_URL +`api/product/${productId}/sum-assured-param-setting`, { observe: 'response' });
  }
  updatePremiumSchedule(productId: number, body: any) {
    return this.http.put(environment.SERVER_API_URL +`api/product/${productId}/premium-schedule-setting`, body, { observe: 'response' });
  }
  readFilePremiumSchedule(body: any) {
    return this.http.post<any>(environment.SERVER_API_URL +`api/product/premium-schedule-setting/read-file`, body);
  }
  getConfigFilterProduct() {
    return this.http.get<any>(environment.SERVER_API_URL +`api/product-type-recommendation-config/list`);
  }
  saveConfigFilterProduct(body) {
    return this.http.post<any>(environment.SERVER_API_URL +`api/product-type-recommendation-config/`, body);
  }
}
